/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ProfileDetailData} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const API_V2_URL = ENV().REACT_APP_API_V2_URL
const initialState: any = {
  FEdashboardCount: [],
  FEdashboardLeadGraph: [],
  FEdashboardInboundMsg: [],
  BEDashboardSaleGraphData: [],
  BEDashboardGraphLine: [],
  BEDashboardGraph: [],
  BEDashboardRecentActivity: [],
  BEDashboardSalesGraphData: [],
  BEDashboardUserActivityData: [],
  LoadingBEdashboardCount: false,
  BEdashboardSalesContacts: null,
  LoadingBEdashboardSalesContacts: false,
}

export const BackendDashboardActivityOverviewCount: any = createAsyncThunk(
  '/BackendDashboardActivityOverviewCount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(
      `${API_URL}report/getAdminDashboardActivityOverviewCount`,
      {
        params: data,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    return response?.data
  }
)

export const BackendDashboardSalesContactsCount: any = createAsyncThunk(
  '/BackendDashboardSalesContactsCount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getAdminDashboardSalesContactsCount`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const BackendDashboardSentNEwClientsBarGraph: any = createAsyncThunk(
  '/BackendDashboardSentNEwClientsBarGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(
      `${API_URL}report/getAdminDashboardMessageSentWithNewClientsBarGraph`,
      {
        params: data,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    return response?.data
  }
)
export const BackendNewMessageLineGraph: any = createAsyncThunk(
  '/BackendNewMessageLineGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(
      `${API_V2_URL}report/getAdminDashboardMessageSentWithNewClientsLineGraph`,
      {
        params: data,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    return response?.data
  }
)
export const BackendDashboardMessageSaleBarGraph: any = createAsyncThunk(
  '/BackendDashboardMessageSaleBarGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(
      `${API_URL}report/getAdminDashboardSMessageSaleBarGraph`,
      {
        params: data,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    return response?.data
  }
)
export const BackendDashboardActivityCount: any = createAsyncThunk(
  '/BackendDashboardActivityCount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getAdminDashboardUserActivityCounts`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const BackendDashboardRecentActivity: any = createAsyncThunk(
  '/BackendDashboardRecentActivity',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_V2_URL}report/allCampaignListReport`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const BackendDashboardSalesGraph: any = createAsyncThunk(
  '/BackendDashboardSalesGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(
      `${API_URL}report/getAdminDashboardSMessageSaleBarGraph`,
      {
        params: data,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    return response?.data
  }
)
export const BackendDashboardUserActivityLineGraph: any = createAsyncThunk(
  '/BackendDashboardUserActivityLineGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(
      `${API_URL}report/getAdminDashboardUserActivityLineGraph`,
      {
        params: data,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    return response?.data
  }
)

const BEDashboardData = createSlice({
  name: 'BEDashboardData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(BackendDashboardActivityOverviewCount.pending, (state) => {
        state.LoadingBEdashboardCount = true
      })
      .addCase(BackendDashboardActivityOverviewCount.fulfilled, (state, {payload}) => {
        state.LoadingBEdashboardCount = false
        state.BEdashboardCount = payload
      })
      .addCase(BackendDashboardActivityOverviewCount.rejected, (state, action) => {
        state.LoadingBEdashboardCount = false
      })
    builder
      .addCase(BackendDashboardSalesContactsCount.pending, (state) => {
        state.LoadingBEdashboardSalesContacts = true
      })
      .addCase(BackendDashboardSalesContactsCount.fulfilled, (state, {payload}) => {
        state.LoadingBEdashboardSalesContacts = false
        state.BEdashboardSalesContacts = payload
      })
      .addCase(BackendDashboardSalesContactsCount.rejected, (state, action) => {
        state.LoadingBEdashboardSalesContacts = false
      })
    builder.addCase(BackendDashboardSentNEwClientsBarGraph.fulfilled, (state, {payload}) => {
      return {...state, BEDashboardGraph: payload}
    })
    builder.addCase(BackendNewMessageLineGraph.fulfilled, (state, {payload}) => {
      return {...state, BEDashboardGraphLine: payload}
    })
    builder.addCase(BackendDashboardRecentActivity.fulfilled, (state, {payload}) => {
      return {...state, BEDashboardRecentActivity: payload}
    })
    builder.addCase(BackendDashboardSalesGraph.fulfilled, (state, {payload}) => {
      return {...state, BEDashboardSalesGraphData: payload}
    })
    builder.addCase(BackendDashboardUserActivityLineGraph.fulfilled, (state, {payload}) => {
      return {...state, BEDashboardUserActivityData: payload}
    })
  },
})

export const getBEDashboardOverview = (state: any) =>
  state?.BackendDashboard?.BEdashboardCount?.data

export const getBEDashboardOverviewLoading = (state: any) =>
  state?.BackendDashboard?.LoadingBEdashboardCount

export const getBEDashboardGraph = (state: any) => state?.BackendDashboard?.BEDashboardGraph?.data
export const getBEDashboardGraphLine = (state: any) =>
  state?.BackendDashboard?.BEDashboardGraphLine?.data
export const getBEDashboardRecentActivity = (state: any) =>
  state?.BackendDashboard?.BEDashboardRecentActivity?.data
export const getBEDashboardSalesData = (state: any) =>
  state?.BackendDashboard?.BEDashboardSalesGraphData?.data
export const getBEDashboardUserActivityData = (state: any) =>
  state?.BackendDashboard?.BEDashboardUserActivityData?.data?.userActivityData?.[0]

export const getBEDashboardSalesContacts = (state: any) =>
  state?.BackendDashboard?.BEdashboardSalesContacts?.data

export const getBEDashboardSalesContactsLoading = (state: any) =>
  state?.BackendDashboard?.LoadingBEdashboardSalesContacts

export default BEDashboardData.reducer
